import React, { useRef, useState, useEffect } from "react";

import { Link, navigate } from "gatsby";
import SlideToggle from "react-slide-toggle";
import scrollTo from "gatsby-plugin-smoothscroll";
import PropTypes from "prop-types";

const menus = [
  { id: "#eligibiity", name: "Eligibility" },
  { id: "#masterview", name: "Managing Trustee's View" },
  { id: "#activities", name: "Activities" },
  { id: "#publication", name: "Publications" },
];

const Header = ({ disableMenuItems }) => {
  const [applySticky, setApplySticky] = useState(false);
  const [menuItems, setMenuItem] = useState(menus);
  const headerRef = useRef();

  const handleHeaderSticky = () => {
    if (headerRef.current && window.pageYOffset > headerRef.current.offsetTop)
      setApplySticky(true);
    else setApplySticky(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const navigateToHome = (link) => {
    navigate(link);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleHeaderSticky);
  }, []);

  useEffect(() => {
    if (disableMenuItems) {
      setMenuItem([
        { id: "/#eligibiity", name: "Eligibility", mode: "navigation" },
        {
          id: "/#masterview",
          name: "Managing Trustee's View",
          mode: "navigation",
        },
        { id: "/#activities", name: "Activities", mode: "navigation" },
        { id: "/#publication", name: "Publications", mode: "navigation" },
      ]);
    }
  }, [disableMenuItems]);

  return (
    <>
      <SlideToggle
        collapsed="true"
        render={({ toggle, setCollapsibleElement }) => (
          <div
            ref={headerRef}
            className={`top-nav top-menu  ${applySticky ? "stickyMenu" : ""}`}
          >
            <div className="container bottom-grey">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <nav className="navbar navbar-expand-lg navbar-light fixed-top top-nav">
                    <Link className="navbar-brand" to="/">
                      <img
                        className="img-fluid logo-mobile"
                        src="images/logo1.png"
                        alt="Heartfulness logo"
                        placeholder="blurred"
                      />
                    </Link>
                    <button
                      className="navbar-toggler"
                      type="button"
                      data-toggle="collapse"
                      data-target="#navbarSupportedContent"
                      aria-controls="navbarSupportedContent"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                      onClick={toggle}
                    >
                      <span className="navbar-toggler-icon" />
                    </button>
                    <div
                      className="navbar-collapse"
                      id="navbarSupportedContent"
                      ref={setCollapsibleElement}
                    >
                      <ul className="navbar-nav ml-auto dynamic-nav">
                        {menuItems.map((item) => (
                          <li className="nav-item">
                            <div
                              onClick={() =>
                                item.mode && item.mode === "navigation"
                                  ? navigateToHome(item.id)
                                  : scrollTo(item.id)
                              }
                              onKeyDown={() =>
                                item.mode && item.mode === "navigation"
                                  ? navigateToHome(item.id)
                                  : scrollTo(item.id)
                              }
                              className="nav-link cursor-pointer"
                              role="button"
                              tabIndex={0}
                            >
                              {" "}
                              {item.name}
                              {""}
                            </div>
                          </li>
                        ))}

                        <li className="nav-item ">
                          <div
                            onClick={() => {
                              navigate("/hrc-report");
                            }}
                            onKeyDown={() => {
                              navigate("/hrc-report");
                            }}
                            className="nav-link cursor-pointer"
                            role="button"
                            tabIndex={0}
                          >
                            {" "}
                            HRC Report 2012-2021{" "}
                          </div>
                        </li>
                      </ul>
                      <button
                        type="button"
                        onClick={() => scrollTo("#contactDetails")}
                        className="btn btn-primary btn-blue mar-15"
                      >
                        {" "}
                        Contact{" "}
                      </button>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        )}
      />
      <div
        role="button"
        tabIndex={0}
        onClick={() => scrollToTop()}
        onKeyDown={() => scrollToTop()}
        className={`top-scroll ${applySticky && "set-height"}`}
      >
        <span className="tp-sc">&#8593;</span>
      </div>
    </>
  );
};

Header.propTypes = {
  disableMenuItems: PropTypes.bool,
};

Header.defaultProps = {
  disableMenuItems: false,
};

export default Header;
